module.exports = __webpack_public_path__ + "static/retail-blog-img-1-63407950e3159624231bb48b28ab672e.png";